import React, {useMemo} from "react";
import { format } from 'date-fns';
import CurrentTemperature from "@appsinti/common-utils/interfaces/weather/CurrentTemperature";
import ForecastTemperature from "@appsinti/common-utils/interfaces/weather/ForecastTemperature";
import { WeatherContainer, WeatherIconContainer } from "./styles";
import WeatherIcon from "@appsinti/ui-core/weather/Icon";
import { useTemperature } from "@appsinti/temperature-provider";
import useI18n from "@appsinti/i18n/useI18n";
import { HeightRestriction, WidthRestriction } from "../../../interfaces/Restrictions";
import { useDateProvider } from "@appsinti/date-provider";

const WeatherInfo: React.FC<{
  widthRestriction: WidthRestriction;
  heightRestriction: HeightRestriction;
  weatherData: {[key: string]: CurrentTemperature|ForecastTemperature}|undefined;
}> = ({ widthRestriction, heightRestriction, weatherData }) => {
  const { temperatureObject } = useTemperature();
  const { translateObject } = useI18n();  
  const { isCurrentDateToday, currentDate } = useDateProvider();

 const selectedWeather: CurrentTemperature|ForecastTemperature|null = useMemo(()=>{
    if( !weatherData ) return null;

    if( isCurrentDateToday )
      return weatherData.today;
    
    if(!currentDate) return null;
    const key = format(currentDate, 'ddMMyyyy');
    return weatherData[key] ? weatherData[key] : null;
 },[weatherData, isCurrentDateToday, currentDate]);

  return selectedWeather && (
    <WeatherContainer className={`${widthRestriction} ${heightRestriction}`}>
      <WeatherIconContainer className={`${widthRestriction} ${heightRestriction}`}>
        <WeatherIcon 
          name={selectedWeather.icon} 
          isDaytime={Object.keys(selectedWeather).includes('isDaytime') ? selectedWeather.isDaytime : undefined}
        />
      </WeatherIconContainer>
      {Object.keys(selectedWeather).includes('temperature') && (
        <p>{temperatureObject(selectedWeather.temperature)}</p>
      )}
      {widthRestriction === "full-width" && (
        <div>
          <p>{translateObject(selectedWeather.summary)}</p>
          <p>{`${temperatureObject(
            selectedWeather.minTemperature
          )} / ${temperatureObject(selectedWeather.maxTemperature)}`}</p>
        </div>
      )}
    </WeatherContainer>
  );
};

export default WeatherInfo;
